var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8.7,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 12.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,40.5H5.9c-0.8,0-1.4-0.6-1.4-1.4V17h39.7v2.4c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2v-7.7 c0-2.1-1.7-3.7-3.7-3.7H5.9c-2.1,0-3.7,1.7-3.7,3.7v27.5c0,2.1,1.7,3.7,3.7,3.7h17.4c0.6,0,1.2-0.5,1.2-1.2S23.9,40.5,23.2,40.5z  M5.9,10.3h36.9c0.8,0,1.4,0.6,1.4,1.4v3H4.5v-3C4.5,10.9,5.1,10.3,5.9,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,23.8c0.6,0,1.2-0.5,1.2-1.2v-0.9c0-1.1-0.9-2-2-2H10.6c-1.1,0-2,0.9-2,2V26c0,1.1,0.9,2,2,2h23.9 c0.6,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2H11v-3.6h26.7v0.5C37.7,23.3,38.2,23.8,38.9,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,30.4c-0.6,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h19.3c0.6,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7,34.7H10c-0.6,0-1.2,0.5-1.2,1.2S9.4,37,10,37h15.6c0.6,0,1.2-0.5,1.2-1.2S26.3,34.7,25.7,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,26.6l-3.3-3.3c-0.5-0.5-1.2-0.5-1.7,0L42,25.8c0,0,0,0,0,0c0,0,0,0,0,0L29.9,37.9 c-0.2,0.2-0.3,0.4-0.3,0.6l-0.9,4.2c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.2,0,0.2,0l4.2-0.9 c0.2,0,0.4-0.2,0.6-0.3l14.6-14.6C50,27.8,50,27.1,49.5,26.6z M45.4,25.8l1.6,1.6l-0.8,0.8l-1.6-1.6L45.4,25.8z M33.5,41l-2.1,0.4 l0.4-2.1l11-11l1.6,1.6L33.5,41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContent);
export default __webpack_public_path__ + "static/media/icon-content.082378e67e40a0546720d491584064f8.svg";
export { ForwardRef as ReactComponent };